<template>
  <gg-card>
    <gg-card-header>
      {{ websitetype }} Location &amp; Hours
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <p>
            If your {{ websitetype }} publishes operation hours, select them here. Otherwise, click Next Step.
          </p>
          <v-switch
            v-model="businessHours"
            :true-value="1"
            :false-value="0"
            :label="'My ' + websitetype + ' has hours'"
          />
          <work-schedule v-if="businessHours"></work-schedule>
        </v-col>
        <v-col cols="12">
          <v-switch
            v-model="hasAddress"
            :label="`My ${websitetype} has a physical address`"
          />
        </v-col>
        <template v-if="hasAddress">
          <v-col cols="12">
            <gg-text-field
              v-model="address"
              label="Address"
              name="address"
              autocomplete="new-password"
            />
          </v-col>
          <v-col cols="12" md="6">
            <gg-text-field
              v-model="city"
              label="City"
              name="city"
              autocomplete="new-password"
            />
          </v-col>
          <v-col cols="12" md="6">
            <gg-text-field
              v-model="state"
              label="State"
              name="state"
              autocomplete="new-password"
            />
          </v-col>
          <v-col cols="12" md="6">
            <gg-text-field
              v-model="postcode"
              label="Postcode"
              name="postcode"
              autocomplete="new-password"
            />
          </v-col>
          <v-col cols="12" md="6">
            <gg-select
              v-model="country"
              :items="countries"
              label="Country"
              name="country"
              item-text="name"
              item-value="name"
            />
          </v-col>
        </template>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import WorkSchedule from './WorkSchedule'

import { countries } from '@/helpers/countries'

export default {
  name: 'WebsiteHours',
  components: { WorkSchedule },
  data () {
    return {
      countries
    }
  },
  computed: {
    ...mapGetters({
      starterSite: 'wizard_model/starterSite'
    }),
    websitetype: {
      get () {
        return this.starterSite.website_type !== 'Other' ? this.starterSite.website_type : 'Other Website'
      }
    },
    businessHours: {
      get () {
        return this.starterSite.businessHours
      },
      set (val) {
        this.SET_SS_BUSINESS_HOURS(val)
      },
    },
    hasAddress: {
      get () {
        return this.starterSite.physicalAddress
      },
      set (val) {
        this.SET_SS_PHYSICAL_ADDRESS(val)
      }
    },
    address: {
      get () {
        return this.starterSite.contactAddress
      },
      set (val) {
        this.SET_SS_ADDRESS(val)
      }
    },
    city: {
      get () {
        return this.starterSite.contactCity
      },
      set (val) {
        this.SET_SS_CITY(val)
      }
    },
    postcode: {
      get () {
        return this.starterSite.contactPostcode
      },
      set (val) {
        this.SET_SS_ZIPCODE(val)
      }
    },
    state: {
      get () {
        return this.starterSite.contactState
      },
      set (val) {
        this.SET_SS_STATE(val)
      }
    },
    country: {
      get () {
        return this.starterSite.contactCountry
      },
      set (val) {
        this.SET_SS_COUNTRY(val)
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_SS_BUSINESS_HOURS: 'wizard_model/SET_SS_BUSINESS_HOURS',
      SET_SS_ADDRESS: 'wizard_model/SET_SS_ADDRESS',
      SET_SS_CITY: 'wizard_model/SET_SS_CITY',
      SET_SS_ZIPCODE: 'wizard_model/SET_SS_ZIPCODE',
      SET_SS_STATE: 'wizard_model/SET_SS_STATE',
      SET_SS_COUNTRY: 'wizard_model/SET_SS_COUNTRY',
      SET_SS_PHYSICAL_ADDRESS: 'wizard_model/SET_SS_PHYSICAL_ADDRESS'
    }),
    validate () {
      return true
    }
  },
}
</script>

<style scoped>

</style>
